import { assign, cloneDeep } from 'lodash'

import * as environment from '../actions/EnvironmentActions'

export default (state = environment.ENVIRONMENT_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case environment.ENVIRONMENT_DEVICE_SET: {
      return state
    }

    case environment.ENVIRONMENT_DEVICE_SET_CANCELED: {
      return state
    }
    case environment.ENVIRONMENT_DEVICE_SET_ERROR: {
      return assign(cloneDeep(state), { device: null, error: action.payload.error })
    }
    case environment.ENVIRONMENT_DEVICE_SET_FULFILLED: {
      return assign(cloneDeep(state), { device: action.payload.device, error: null })
    }

    case environment.ENVIRONMENT_LOCATION_SET: {
      return assign(cloneDeep(state), {
        location: assign({}, state.location, action.payload, {
          count: (state.location.count || 0) + 1,
        }),
      })
    }
    case environment.ENVIRONMENT_LOCATION_SET_CANCELED: {
      const newState = assign(cloneDeep(state))
      newState.location.count = (state.location.count || 1) - 1
      return newState
    }
    case environment.ENVIRONMENT_LOCATION_SET_ERROR: {
      return assign(cloneDeep(state), {
        location: assign({}, state.location, action.payload, {
          count: (state.location.count || 1) + 1,
        }),
      })
    }
    case environment.ENVIRONMENT_LOCATION_SET_FULFILLED: {
      return assign(cloneDeep(state), {
        location: assign({}, state.location, action.payload, {
          count: state.location.count || 0,
        }),
      })
    }

    case environment.ENVIRONMENT_ONLINE_SET: {
      return { ...state, onLine: action.payload }
    }
    case environment.ENVIRONMENT_SET: {
      return state
    }
    case environment.ENVIRONMENT_SET_CANCELED: {
      return state
    }
    case environment.ENVIRONMENT_SET_ERROR: {
      return assign(cloneDeep(environment.ENVIRONMENT_INITIAL_STATE), {
        error: action.payload.error,
      })
    }

    case environment.ENVIRONMENT_SET_FULFILLED: {
      return assign(cloneDeep(state), { error: null })
    }
    case environment.ENVIRONMENT_STAGE_SET: {
      return state
    }

    case environment.ENVIRONMENT_STAGE_SET_CANCELED: {
      return state
    }
    case environment.ENVIRONMENT_STAGE_SET_ERROR: {
      return assign(cloneDeep(state), { error: action.payload.error, stage: {} })
    }
    case environment.ENVIRONMENT_STAGE_SET_FULFILLED: {
      return assign(cloneDeep(state), { error: null, stage: action.payload.stage })
    }
    case environment.ENVIRONMENT_VISIBILITY_SET: {
      return { ...state, visibility: action.payload }
    }
    default:
  }
  return state
}
